module.exports = __webpack_public_path__ + "static/img/case_5.56b5ce0c.jpg";